import React, { memo, useEffect, useMemo, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from "axios";
import moment from 'moment-timezone';
import { Col, Container, Modal, Row } from 'react-bootstrap';
import SeedHeader from './SeedHeader';
import SeedBody from './SeedBody';
import { CHAT_BOT_BASE_URL } from '../../constants/utils';
import { leftSideToggle } from '../../actions/user';
import { getSeedHistory, getSeedSupplier, getSeedVariety, getSeedLot, getSeedTareLoad, getSeedType, getSeedCuttingGroup } from '../../actions/plan';
import { getLoadDate, getTotalCapacity, sortFn } from './seedHelper';
import { DISPLAY_DATE_FORMAT2 } from '../../constants';
import { toDisplayDateString, toDisplayDateTimeString, toDisplayTimeString } from '../../helpers/moment-ex';
import { formatNumber, Unit } from '../../helpers/unit';
import {
  loadHistory, getHarvesterList, getEquipmentGroupList, equipmentGroupList,
  getGeoShapeList, getGeoRegionList,
} from '../../actions/equipment-group';
import '../../../assets/scss/seed-history.scss';
import replyBotIcon from "../../../assets/images/aiChat/replybot.svg"
import geminiAiIcon from "../../../assets/images/aiChat/gemini-ai.svg"
import { getOperatorList, operatorList } from '../../actions/person';
import { getFarmAddress, getFarmSettings } from '../../actions/farm';
import { getDateRangeInfo } from '../../actions/analyze';
import { setAiChatBotId, setIsLoadHistoryReload } from "../../actions/load";
import { getSettings } from '../../actions/user';
import { getRateScheduleLists } from '../../actions/rate-schedule';
import { usePermission } from '../../helpers/common';
import OffCanvasAi from '../layout/offcanvas/OffCanvasAi';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SeedHistoryContent = (props) => {
  const params = useParams();
  const querySearchParams = useQuery();
  const allow = usePermission();
  const dispatch = useDispatch();
  const { filterIds } = useSelector(state => state.plan.seedHistory);
  const categeryId = querySearchParams.get('catId');
  const isAiBotEnable = false;

  const isFormatToSmallScale = false;
  const unit = Unit.getInstance();

  const { farmId, crewId, egId, isTruck, type } = params;
  const isFarmView = !crewId && !egId;

  const { rangeId, range, custom } = useSelector(state => state.analyze.searchParams);
  const { isRequesting, data } = useSelector(state => state.plan.seedHistory);
  const tareLoadHistory = useSelector(state => state.plan.tareLoadHistory);
  const { weightShortName/* , areaShortName */ } = useSelector(state => state.user.settings);
  const fieldListById = useSelector(state => state.equipmentGroup.fieldListById.payload);
  const { searchText } = useSelector(state => state.plan);
  // const [isChatAvailable, setIsChatAvailable] = useState(false);
  const aiChatBotId = useSelector(state => state.load.aiChatBotId);
  const userSettings = useSelector(state => state.user.userSettings);
  const userId = useSelector((state) => state.auth.userInfo.userId);
  const farmConfig = useSelector(state => state.farm.farmSettings.farm_config);
  const loadHistoryReload = useSelector((state) => state.load.loadHistoryReload);
  const { is_planter_allocation = {} } = farmConfig || {};
  const isPlanterAllocation = (is_planter_allocation && is_planter_allocation.visible);

  const [filteredName, setFilteredName] = useState(null);
  const [selectedViewType, setSelectedViewType] = useState(1);
  // const planTypeId = useSelector(state => state.plan.selectedPlanType);
  const [aiChatHistory, setAiChatHistory] = useState(true);
  const [chatBotModal, setChatBotModal] = useState(false);
  const [loadParams, setLoadParams] = useState([]);

  const onAiHide = () => {
    setChatBotModal(false)
  }

  useEffect(() => {
    dispatch(leftSideToggle());
    return () => {
      dispatch(leftSideToggle());
    };
  }, []);

  useEffect(() => {
    if (farmId) {
      /* const paramsObj = {
        farm_uuid: farmId,
        range_type: range,
        from_date: custom.from,
        to_date: custom.to,
        plan_type_id: 2,
        include_events: true,
      };

      if (type === 'crew' && crewId) paramsObj['crew_uuid'] = crewId
      if (isTruck === 'false' && egId) paramsObj['target_equipment_group_uuid'] = egId;
      if (isTruck === 'true' && egId) paramsObj['source_equipment_group_uuid'] = egId; 
      dispatch(getSeedHistory(paramsObj));*/
      dispatch(getRateScheduleLists(farmId));
      getSeedHistoryList();
      getSeedTareHistory();
      dispatch(getGeoRegionList({ farmId }));
      dispatch(getHarvesterList({ farmId, selectedPlanType: 2 }));
      dispatch(getGeoShapeList(farmId));
      dispatch(getOperatorList({ farmId }));
      dispatch(getEquipmentGroupList({ farmId, selectedPlanType: 2 }));
      dispatch(getFarmAddress(farmId));
      dispatch(getSeedVariety(farmId));
      dispatch(getSeedSupplier(farmId));
      dispatch(getSeedLot(farmId));
      dispatch(getSeedType(farmId));
      dispatch(getSeedCuttingGroup(farmId));
      dispatch(getFarmSettings({ farm_uuid: farmId, plan_type_id: 2 }))
      dispatch(getSettings());
    }

    return () => {
      dispatch(loadHistory());
      dispatch(equipmentGroupList());
      dispatch(operatorList());
    };
  }, [farmId, rangeId]);

  const getSeedHistoryList = () => {
    if (farmId) {
      const paramsObj = {
        farm_uuid: farmId,
        range_type: range,
        from_date: custom.from,
        to_date: custom.to,
        plan_type_id: 2,
        include_events: true,
      };

      if (type === 'crew' && crewId) paramsObj['crew_uuid'] = crewId
      if (isTruck === 'false' && egId && categeryId !== '4') paramsObj['source_equipment_group_uuid'] = egId;
      if (isTruck === 'true' && egId) paramsObj['target_equipment_group_uuid'] = egId;
      if (isTruck === 'false' && egId && categeryId === '4') paramsObj['target_equipment_group_uuid'] = egId;

      dispatch(getSeedHistory(paramsObj));
    }
  }

  const getSeedTareHistory = () => {
    const dateInfo = dispatch(getDateRangeInfo());
    const loadParams = {
      farm_uuid: farmId,
      egId: egId ? egId : null,
      include_events: true,
      range_type: dateInfo.range,
      from_date: dateInfo.fromDate,
      to_date: dateInfo.toDate,
      is_tareload: true,
      crew_uuid: crewId
    };
    dispatch(getSeedTareLoad(loadParams));
  };

  useEffect(() => {
    if (loadHistoryReload) {
      getSeedHistoryList();
      dispatch(setIsLoadHistoryReload(false));
    }
  }, [loadHistoryReload])

  const initialLoads = {
    seedHistory: {
      isRequesting: false,
      title: "Seed History",
      header: [
        { key: "id", name: null, label: "#", filter: 'id', isPipeFilter: false, isSort: false, isShow: true, width: "20px" },
        { key: "crew_name", filter: 'crew_uuid', name: "crew_name", label: "Crew", isPipeFilter: true, isSort: true, isShow: true },
        // { key: "supplier", filter: 'supplier', name: "supplier", label: "Seed Supplier", isPipeFilter: true, isSort: true, isShow: true },
        // { key: "variety_name", filter: 'variety_name', name: "variety_name", label: "Seed Variety", isPipeFilter: true, isSort: true, isShow: true },
        // { key: "seed_type", filter: 'seed_type', name: "seed_type", label: "Seed Type", isPipeFilter: true, isSort: true, isShow: true },
        // { key: "seed_class", filter: 'seed_class', name: "seed_class", label: "Seed Class", isPipeFilter: false, isSort: true, isShow: true },
        // { key: "seed_lot", filter: 'seed_lot', name: "seed_lot", label: "Seed Lot", isPipeFilter: true, isSort: true, isShow: true },
        // { key: "seed_cutting_group", filter: 'seed_cutting_group', name: "seed_cutting_group", label: "Seed Cutting Group", isPipeFilter: true, isSort: true, isShow: true },
        // { key: "average_seed_size", filter: 'average_seed_size', name: "average_seed_size", label: "Average Seed Size", isPipeFilter: false, isSort: true, isShow: true },
        { key: "scale_ticket", filter: 'scale_ticket', name: "scale_ticket", label: "Scale Ticket", isPipeFilter: false, isSort: true, isShow: true },
        { key: "truck_name", filter: 'truck_name', name: "truck_name", label: "Truck", isPipeFilter: false, isSort: false, isShow: true },
        { key: "offload_geo_shape_name", filter: 'offload_geo_shape_uuid', name: "offload_geo_shape_name", label: "Offload (Load Origin)", isPipeFilter: true, isSort: true, isShow: true },
        { key: "offload_geo_storage_location_name", filter: 'offload_geo_storage_location_uuid', name: "offload_geo_storage_location_name", label: "Storage", isPipeFilter: true, isSort: true, isShow: true },
        { key: "load_gross_weight", filter: 'load_gross_weight', name: null, label: `Gross Weight (${weightShortName})`, isPipeFilter: false, isSort: true, isShow: true, width: "120px" },
        { key: "tare_weight", filter: 'tare_weight', name: null, label: `Tare Weight (${weightShortName})`, isPipeFilter: false, isSort: true, isShow: true, width: "120px" },
        { key: "light_weight", filter: 'light_weight', name: null, label: `Light Weight (${weightShortName})`, isPipeFilter: false, isSort: true, isShow: true, width: "120px" },
        { key: "load_capacity", filter: 'load_capacity', name: null, label: `Load Weight (${weightShortName})`, isPipeFilter: true, isSort: true, isShow: true, width: "120px" },
        { key: "target_equipment_group_name", filter: 'target_equipment_group_uuid', name: "target_equipment_group_name", label: "Target EG", isPipeFilter: true, isSort: true, isShow: true },
        { key: "target_equipment_vendor_name", label: "Vendor", filter: 'target_equipment_vendor_id', name: "target_equipment_vendor_name", isPipeFilter: true, isSort: true, isShow: true },
        { key: "source_equipment_group_name", filter: 'source_equipment_group_uuid', name: "source_equipment_group_name", label: "Source EG", isPipeFilter: true, isSort: true, isShow: true },
        { key: "field_geo_shape_name", filter: 'field_geo_shape_uuid', name: "field_geo_shape_name", label: "Field (Load Destination)", isPipeFilter: true, isSort: true, isShow: true },
        { key: "crop_name", label: "Crop", filter: 'crop_name', name: "crop_name", isPipeFilter: true, isSort: true, isShow: true },
        { key: "load_date", filter: 'load_date', name: null, label: "Load Time", isPipeFilter: false, isSort: false, isShow: true },
        { key: "load_seconds", filter: 'load_seconds', name: null, label: "Duration", isPipeFilter: true, isSort: false, isShow: true, width: '100px' },
        { key: "round_trip_load_time_format", filter: 'round_trip_load_time_format', name: null, label: "Roundtrip Load Time", isPipeFilter: false, isSort: false, isShow: true },
        { key: "completed", label: "Completed", isPipeFilter: false, name: 'completed', filter: 'completed', isSort: true, isShow: isPlanterAllocation },
        { key: "approved", label: "Approved", isPipeFilter: true, name: 'approved', filter: "approved", isSort: true, isShow: true, },
        { key: "load_sequence", label: "Planter Allocation", isPipeFilter: false, filter: "load_sequence", name: 'load_sequence', isSort: true, isShow: isPlanterAllocation },
        { key: "distance", label: "Estimated Distance (miles)", isPipeFilter: false, filter: "distance", name: 'distance', isSort: true, isShow: true },
        { key: "travelled_distance", label: "Travelled Distance (miles)", isPipeFilter: false, filter: "travelled_distance", name: 'distance', isSort: true, isShow: true },
        { key: "rate_info", label: "Rates", isPipeFilter: false, filter: "rate_info", name: 'distance', isSort: false, isShow: true },
        { key: "action", filter: 'action', name: null, label: "Action", isPipeFilter: false, isSort: false, isShow: true },
      ],
      body: []
    },
    loadsForTheDay: {
      isRequesting: true,
      title: "Total loads for the Day",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "load_date", label: "Load Date", width: "300px" },
        { key: "load_count", label: "Loads", width: "80px" },
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "120px" }
      ],
      body: []
    },
    /* dailyLoadsPerOffloadSite: {
      isRequesting: true,
      title: "Daily loads per Offload Site",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "load_date", label: "Load Date", width: "150px" },
        { key: "offload_geo_shape_name", label: "Offload Site", width: "150px" },
        { key: "load_count", label: "Loads", width: "80px" },
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "120px" }
      ],
      body: []
    }, */
    loadsPerLoadOrigin: {
      isRequesting: true,
      title: "Total loads per Load Origin",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "offload_geo_shape_name", label: "Load Origin", width: "300px" },
        { key: "load_count", label: "Loads", width: "80px" },
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "120px" },
        /* ...isFarmView ? [{ key: "total_area", label: `Total ${areaShortName}`, width: "80px" },
        { key: "worked_area", label: `Worked ${areaShortName}`, width: "120px" }] : [] */
      ],
      body: []
    },
    loadsPerSeedCutter: {
      isRequesting: true,
      title: "Total loads per Load Origin (EG)",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "source_equipment_group_name", label: "Source EG", width: "300px" },
        { key: "load_count", label: "Loads", width: "80px" },
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "120px" }
      ],
      body: []
    },
    loadsPerTargetEG: {
      isRequesting: true,
      title: "Total loads per Target EG",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "target_equipment_group_name", label: "Target EG", width: "300px" },
        { key: "load_count", label: "Loads", width: "80px" },
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "120px" }
      ],
      body: []
    },
    loadsPerField: {
      isRequesting: true,
      title: `Total Weight per Field`,
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "field_geo_shape_name", label: "Field", width: "300px" },
        /* { key: "load_count", label: "Loads", width: "80px" }, */
        /* ...isFarmView ? [{ key: "total_area", label: `Total ${areaShortName}`, width: "80px" },
        { key: "worked_area", label: `Worked ${areaShortName}`, width: "120px" }] : [], */
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "120px" }
      ],
      body: []
    },
    /* loadsPerSeedSupplier: {
      isRequesting: true,
      title: `Total Load per Seed Supplier`,
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "supplier", label: "Seed Supplier", width: "300px" },
        { key: "load_count", label: "Loads", width: "80px" },
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "120px" }
      ],
      body: []
    },
    loadsPerSeedVariety: {
      isRequesting: true,
      title: `Total Load per Seed Variety`,
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "variety_name", label: "Seed Variety", width: "300px" },
        { key: "load_count", label: "Loads", width: "80px" },
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "120px" }
      ],
      body: []
    }, */
    loadsPerPlanter: {
      isRequesting: true,
      isPlanter: true,
      title: `Total Weight per Planter`,
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "target_equipment_group_name", label: "Planter", width: "300px" },
        /* ...isFarmView ? [{ key: "total_area", label: `Total ${areaShortName}`, width: "80px" },
        { key: "worked_area", label: `Worked ${areaShortName}`, width: "120px" }] : [], */
        /* { key: "load_count", label: "Loads", width: "80px" }, */
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "120px" }
      ],
      body: []
    },
    fieldWeightbySeedVariety: {
      isRequesting: true,
      title: "Weight by Seed Variety (Field)",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "variety_name", label: "Seed Variety", width: "300px" },
        { key: "geo_shape_name", label: "Field Name", width: "300px" },
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "120px" }
      ],
      body: []
    },
    planterWeightbySeedVariety: {
      isRequesting: true,
      isPlanter: true,
      title: "Weight by Seed Variety (Planter)",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "variety_name", label: "Seed Variety", width: "300px" },
        { key: "target_equipment_group_name", label: "Planter Name", width: "300px" },
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "120px" }
      ],
      body: []
    },
    fieldWeightbySeedSupplier: {
      isRequesting: true,
      title: "Weight by Seed Supplier (Field)",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "supplier", label: "Seed Supplier", width: "300px" },
        { key: "geo_shape_name", label: "Field Name", width: "300px" },
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "120px" }
      ],
      body: []
    },
    planterWeightbySeedSupplier: {
      isRequesting: true,
      isPlanter: true,
      title: "Weight by Seed Supplier (Planter)",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "supplier", label: "Seed Supplier", width: "300px" },
        { key: "target_equipment_group_name", label: "Planter Name", width: "300px" },
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "120px" }
      ],
      body: []
    },
    loadsPerStorageLocation: {
      isRequesting: true,
      title: "Total loads per Storage",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "offload_geo_shape_name", label: "Offload Site", width: "160px" },
        { key: "offload_geo_storage_location_name", label: "Storage", width: "160px" },
        { key: "load_count", label: "Loads", width: "50px" },
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "60px" },
        { key: "first_load_date", label: `Start Date`, width: "260px" },
        { key: "last_load_date", label: `End Date`, width: "260px" }
      ],
      body: []
    },
    loadsPerTransportEG: {
      isRequesting: true,
      title: "Total loads per Transport EG",
      header: [
        { key: "id", label: "#", width: "40px" },
        { key: "transport_equipment_group_name", label: "Transport EG", width: "300px" },
        { key: "load_count", label: "Loads", width: "80px" },
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, width: "120px" }
      ],
      body: []
    },
    tareLoads: {
      isRequesting: false,
      title: "Tare History",
      header: [
        { key: "id", label: "#" },
        { key: "crew_name", label: "Crew", show: true, filter: false },
        { key: "source_equipment_group_name", label: "Source EG", show: true, filter: false },
        { key: "source_operator_name", label: "Source EG Operator", show: true, filter: false },
        { key: "target_equipment_group_name", label: "Target EG", show: true, filter: false },
        { key: "operator_name", label: "Target EG Operator", show: true, filter: false },
        { key: "offload_geo_shape_name", label: "Offload Site", show: true, filter: false },
        { key: "offload_geo_storage_location_name", label: "Storage", show: true, filter: false },
        { key: "load_capacity", label: `Load Weight (${weightShortName})`, show: true, filter: false },
        { key: "load_date", label: "Load Time", show: true, filter: false },
      ],
      body: []
    },
    RateDetails: {
      isRequesting: false,
      title: "Rate Details",
      header: [
        { key: "id", label: "#" },
        { key: "rate_name", label: "Rate" },
        { key: "eg_list", label: "Truck" }
      ],
      body: []
    }
  };

  const [loads, setLoads] = useState(initialLoads);
  const [seedHistory, setSeedHistory] = useState(initialLoads);

  let customColumns = initialLoads.seedHistory.header.map(
    (item) => item.isShow && item.key
  );

  const getTableDetails = (type, loadList) => {
    if (loadList.length <= 0) return [];

    const replaceStr = str => (str && str !== 'null' && typeof str === 'string') ? str.trim().replace(/(\r\n|\n|\r)/gm, " ") : "Unknown";
    if (type === "seedHistory") {
      const dataList = [...loadList].map(e => ({
        ...e,
        load_activity_uuid: e.load_activity_uuid,
        crew_name: replaceStr(e.crew_name),
        // supplier: replaceStr(e.supplier),
        // variety_name: e.variety_name ? replaceStr(e.variety_name) : replaceStr(e.variety),
        // seed_lot: replaceStr(e.hasOwnProperty('seed_lot') ? e.seed_lot : ''),
        source_equipment_group_name: replaceStr(e.source_equipment_group_name),
        source_operator_name: replaceStr(e.source_operator_name),
        target_equipment_group_name: replaceStr(`${e.target_equipment_group_name}${(e.anonymous_eg === 1) ? '*' : ''}`),
        operator_name: replaceStr(e.operator_name),
        transload_geo_shape_name: replaceStr(e.transload_geo_shape_name),
        transport_equipment_group_name: replaceStr(e.transport_equipment_group_name),
        transport_operator_name: replaceStr(e.transport_operator_name),
        field_geo_region_name: replaceStr(e.field_geo_region_name),
        offload_geo_region_name: replaceStr(e.offload_geo_region_name),
        field_geo_shape_name: replaceStr(e.field_geo_shape_name),
        offload_geo_shape_name: replaceStr(e.offload_geo_shape_name),
        offload_geo_storage_location_name: replaceStr(e.offload_geo_storage_location_name),
        pipe: replaceStr(e.pipe),
        estimated_load_capacity: e.estimated_load_capacity ? unit.toFixedOf(e.estimated_load_capacity, 2) : 0,
        load_gross_weight: e.load_gross_weight ? unit.toFixedOf(e.load_gross_weight, 2) : 0,
        tare_weight: e.tare_weight ? unit.toFixedOf(e.tare_weight, 2) : 0,
        light_weight: e.light_weight ? unit.toFixedOf(e.light_weight, 2) : 0,
        load_capacity: e.load_capacity ? unit.toFixedOf(e.load_capacity, 2) : 0,
        completed: (e.completed > 0) ? 'Yes' : 'No',
        completed_date: (e.completed > 0) ? toDisplayDateString(e.completed_date_tz) : '',
        approved: e.approved > 0 ? "Yes" : "No",
        approved_date: e.approved > 0 ? toDisplayDateString(e.approved_date_tz) : "",
        meta_data: (e.meta_data && e.meta_data.location) ? `${e.meta_data.location.latitude}, ${e.meta_data.location.longitude}` : 'Unknown',
        truck_name: e.truck_name && e.truck_name.length !== 0 ? e.truck_name.toString() : null,
        truck_name_list: e.truck_name ? e.truck_name : [],
        truck_list: e.truck_uuid ? e.truck_uuid : [],
        scale_ticket: e.scale_ticket && e.scale_ticket.length !== 0 ? e.scale_ticket.toString() : null,
        scale_ticket_list: e.scale_ticket ? e.scale_ticket : [],
        crop_name: replaceStr(e.crop_name),
        target_equipment_vendor_name: replaceStr(e.target_equipment_vendor_name),
        load_date: e.load_date ? toDisplayDateTimeString(e.load_date, false, false) : null,
        field_geo_shape_properties: e.field_geo_shape_properties ? e.field_geo_shape_properties : null,
        round_trip_load_time_format: toDisplayTimeString(e.round_trip_load_time),
        ...e.load_params ? e.load_params : null,
        distance: e.distance_info && e.distance_info.distance ? unit.toFixedOf(e.distance_info.distance, 2) : "Unknown",
        travelled_distance: e.distance_info && e.distance_info.travelled_distance ? unit.toFixedOf(e.distance_info.travelled_distance, 2) : "Unknown",
        rate_info: e.rate_info ? e.rate_info : "Unknown"
        // target_equipment_vendor_id: e.target_equipment_vendor_name ? e.target_equipment_vendor_name.toString() : null,
      }));

      return dataList;
    }
    else if (type === "loadsForTheDay") {
      const sortedList = [...loadList].sort((a, b) => sortFn("asc", "date", "load_date", a, b));

      const loads = sortedList.reduce((listById, item) => {
        const value = moment.utc(item.load_date).format(DISPLAY_DATE_FORMAT2);
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      const dataList = Object.keys(loads).map(e => ({
        load_date: e,
        load_capacity: getTotalCapacity(loads[e], isFormatToSmallScale, unit),
        load_count: loads[e].length
      }));
      return dataList;
    } else if (type === "dailyLoadsPerOffloadSite") {
      const sortedList = [...loadList].sort((a, b) => sortFn("asc", "date", "load_date", a, b));

      const loads = sortedList.reduce((listById, item) => {
        const value = moment.utc(item.load_date).format(DISPLAY_DATE_FORMAT2);
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      const data = Object.keys(loads).map(e1 => {
        const loads2 = loads[e1].reduce((listById, item) => {
          const value = item.offload_geo_shape_uuid;
          listById[value] = (listById[value] || []).concat(item);
          return listById;
        }, {});

        return Object.keys(loads2).map(e2 => ({
          load_date: e1,
          offload_geo_shape_uuid: replaceStr(loads2[e2][0].offload_geo_shape_uuid),
          offload_geo_shape_name: replaceStr(loads2[e2][0].offload_geo_shape_name),
          load_capacity: getTotalCapacity(loads2[e2], isFormatToSmallScale, unit),
          load_count: loads2[e2].length
        })).sort((a, b) => sortFn("desc", "number", "load_count", a, b));
      });

      let dataList = [];
      data.forEach(item => dataList = [...dataList, ...item]);

      return dataList;
    } else if (type === "loadsPerLoadOrigin") {
      const loads = loadList.reduce((listById, item) => {
        const value = item.offload_geo_shape_uuid;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => {
        const shapeId = loads[e][0].offload_geo_shape_uuid;
        return ({
          offload_geo_shape_uuid: replaceStr(shapeId),
          offload_geo_shape_name: replaceStr(loads[e][0].offload_geo_shape_name),
          load_capacity: getTotalCapacity(loads[e], isFormatToSmallScale, unit),
          load_count: loads[e].length,
          ...isFarmView && {
            total_area: fieldListById[shapeId] ? fieldListById[shapeId].totalArea : "-",
            worked_area: fieldListById[shapeId] ? unit.toFixedOf(fieldListById[shapeId].workedArea, 2) : "-"
          }
        });
      });

      dataList = dataList.sort((a, b) => sortFn("desc", "number", "load_count", a, b));

      const unknownData = dataList.filter(item => item.field_geo_shape_uuid === "field_unknown");
      const knownData = dataList.filter(item => item.field_geo_shape_uuid !== "field_unknown");
      dataList = [...unknownData, ...knownData];
      return dataList;
    } else if (type === "loadsPerField") {
      let sequenceLoadList = [];
      loadList.forEach((e) => {
        if (e && e.load_sequence && e.load_sequence.length > 0) {
          sequenceLoadList.push(...e.load_sequence);
        }
      });

      const loads = sequenceLoadList.reduce((listById, item) => {
        const value = item.geo_shape_uuid;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => {
        const shapeId = loads[e][0].geo_shape_uuid;
        return ({
          field_geo_shape_uuid: replaceStr(shapeId),
          field_geo_shape_name: replaceStr(loads[e][0].geo_shape_name),
          load_capacity: getTotalCapacity(loads[e], isFormatToSmallScale, unit),
          load_count: loads[e].length,
          ...isFarmView && {
            total_area: fieldListById[shapeId] ? fieldListById[shapeId].totalArea : "-",
            worked_area: fieldListById[shapeId] ? unit.toFixedOf(fieldListById[shapeId].workedArea, 2) : "-"
          }
        });
      });

      if (!isPlanterAllocation) {
        const loadsData = loadList.reduce((listById, item) => {
          const value = item.field_geo_shape_uuid;
          listById[value] = (listById[value] || []).concat(item);
          return listById;
        }, {});

        dataList = Object.keys(loadsData).map((e) => {
          const shapeId = loadsData[e][0].field_geo_shape_uuid;
          return ({
            field_geo_shape_uuid: replaceStr(shapeId),
            field_geo_shape_name: replaceStr(loadsData[e][0].field_geo_shape_name),
            load_capacity: getTotalCapacity(loadsData[e], isFormatToSmallScale, unit),
            load_count: loadsData[e].length,
            ...isFarmView && {
              total_area: fieldListById[shapeId] ? fieldListById[shapeId].totalArea : "-",
              worked_area: fieldListById[shapeId] ? unit.toFixedOf(fieldListById[shapeId].workedArea, 2) : "-"
            }
          });
        });
      }

      dataList = dataList.sort((a, b) => sortFn("desc", "number", "load_count", a, b));
      const unknownData = dataList.filter(item => item.field_geo_shape_uuid === "field_unknown");
      const knownData = dataList.filter(item => item.field_geo_shape_uuid !== "field_unknown");
      dataList = [...unknownData, ...knownData];
      return dataList;
    } else if (type === 'loadsPerPlanter') {
      let sequenceLoadList = [];
      loadList.forEach((e) => {
        if (e && e.load_sequence && e.load_sequence.length > 0) {
          sequenceLoadList.push(...e.load_sequence);
        }
      });

      const loads = sequenceLoadList.reduce((listById, item) => {
        const value = item.target_equipment_group_uuid;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => {
        const shapeId = loads[e][0].geo_shape_uuid;
        return {
          target_equipment_group_uuid: replaceStr(loads[e][0].target_equipment_group_uuid),
          target_equipment_group_name: replaceStr(loads[e][0].target_equipment_group_name),
          load_capacity: getTotalCapacity(loads[e], isFormatToSmallScale, unit),
          load_count: loads[e].length,
          ...isFarmView && {
            total_area: fieldListById[shapeId] ? fieldListById[shapeId].totalArea : "-",
            worked_area: fieldListById[shapeId] ? unit.toFixedOf(fieldListById[shapeId].workedArea, 2) : "-"
          }
        }

      });

      dataList = dataList.sort((a, b) => sortFn("desc", "number", "load_count", a, b));

      const unknownData = dataList.filter(item => item.source_equipment_group_uuid === "implement_unknown");
      const knownData = dataList.filter(item => item.source_equipment_group_uuid !== "implement_unknown");
      dataList = [...unknownData, ...knownData];
      return dataList;
    } else if (type === "loadsPerSeedCutter") {
      const loads = loadList.reduce((listById, item) => {
        const value = item.source_equipment_group_uuid;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => ({
        source_equipment_group_uuid: replaceStr(loads[e][0].source_equipment_group_uuid),
        source_equipment_group_name: replaceStr(loads[e][0].source_equipment_group_name),
        load_capacity: getTotalCapacity(loads[e], isFormatToSmallScale, unit),
        load_count: loads[e].length,
      }));

      dataList = dataList.sort((a, b) => sortFn("desc", "number", "load_count", a, b));

      const unknownData = dataList.filter(item => item.source_equipment_group_uuid === "implement_unknown");
      const knownData = dataList.filter(item => item.source_equipment_group_uuid !== "implement_unknown");
      dataList = [...unknownData, ...knownData];

      return dataList;
    } else if (type === "loadsPerTargetEG") {
      const loads = loadList.reduce((listById, item) => {
        const value = item.target_equipment_group_uuid;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => ({
        target_equipment_group_uuid: replaceStr(loads[e][0].target_equipment_group_uuid),
        target_equipment_group_name: replaceStr(`${loads[e][0].target_equipment_group_name}${(loads[e][0].anonymous_eg === 1) ? '*' : ''}`),
        load_capacity: getTotalCapacity(loads[e], isFormatToSmallScale, unit),
        load_count: loads[e].length
      }));

      dataList = dataList.sort((a, b) => sortFn("desc", "number", "load_count", a, b));

      const unknownData = dataList.filter(item => item.target_equipment_group_uuid === "transport_unknown");
      const knownData = dataList.filter(item => item.target_equipment_group_uuid !== "transport_unknown");
      dataList = [...unknownData, ...knownData];
      return dataList;
    } else if (type === "loadsPerStorageLocation") {
      const loads = loadList.reduce((listById, item) => {
        const value = `${item.offload_geo_storage_location_uuid}-${item.offload_geo_shape_uuid}`;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => {
        let loadDate = getLoadDate(loads[e]);
        return ({
          offload_geo_storage_location_uuid: replaceStr(loads[e][0].offload_geo_storage_location_uuid),
          offload_geo_storage_location_name: replaceStr(loads[e][0].offload_geo_storage_location_name),
          offload_geo_shape_name: replaceStr(`${loads[e][0].offload_geo_shape_name}`),
          load_capacity: getTotalCapacity(loads[e], isFormatToSmallScale, unit),
          load_count: loads[e].length,
          first_load_date: loadDate[0],
          last_load_date: loadDate[1]
        });
      });

      dataList = dataList.sort((a, b) =>
        a.offload_geo_shape_name.localeCompare(b.offload_geo_shape_name) || (b.load_count - a.load_count));

      return dataList;
    } else if (type === "loadsPerTransportEG") {
      const loads = loadList.reduce((listById, item) => {
        const value = item.transport_equipment_group_uuid;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => ({
        transport_equipment_group_uuid: replaceStr(loads[e][0].transport_equipment_group_uuid),
        transport_equipment_group_name: replaceStr(loads[e][0].transport_equipment_group_name),
        load_capacity: getTotalCapacity(loads[e], isFormatToSmallScale, unit),
        load_count: loads[e].length
      }));

      dataList = dataList.sort((a, b) => sortFn("desc", "number", "load_count", a, b));

      // const unknownData = dataList.filter(item => item.transport_equipment_group_uuid === "transport_eg_unknown");
      const knownData = dataList.filter(item => item.transport_equipment_group_uuid !== "transport_eg_unknown");
      dataList = [...knownData];
      return dataList;
    } else if (type === "tareLoads") {
      const dataList = [...loadList].map(e => ({
        crew_name: replaceStr(e.crew_name),
        source_equipment_group_name: replaceStr(e.source_equipment_group_name),
        source_operator_name: replaceStr(e.source_operator_name),
        target_equipment_group_name: replaceStr(e.target_equipment_group_name),
        operator_name: replaceStr(e.operator_name),
        offload_geo_shape_name: replaceStr(e.offload_geo_shape_name),
        offload_geo_storage_location_name: replaceStr(e.offload_geo_storage_location_name),
        load_capacity: unit.toFixedOf(e.load_capacity, 2),
        load_date: e.load_date ? toDisplayDateString(e.load_date) : null,
      }));
      return dataList;

    } else if (type === "fieldWeightbySeedVariety") {
      const loadSquences = [];
      loadList.forEach((item) => {
        if (item.load_sequence && item.load_sequence.length > 0) {
          loadSquences.push(...item.load_sequence.map((e) => ({
            ...e,
            supplier: item.load_params && item.load_params.supplier ? item.load_params.supplier : null,
            variety_name: item.load_params && item.load_params.variety_name ? item.load_params.variety_name : null
          })))
        }
      });
      const loads = loadSquences.reduce((listById, item) => {
        const value = item.geo_shape_uuid;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = [];
      Object.keys(loads).forEach((shapeId) => {
        const seedVariety = loads[shapeId].reduce((listById, item) => {
          const value = item.load_params && item.load_params.variety_name ? item.load_params.variety_name : null;
          listById[value] = (listById[value] || []).concat(item);
          return listById;
        }, {});

        Object.keys(seedVariety).forEach((item) => {
          let supplier = seedVariety[item] && seedVariety[item].length > 0 ? seedVariety[item] : null;
          dataList.push({
            variety_name: supplier && supplier[0].variety_name ? supplier[0].variety_name : 'Unknown',
            geo_shape_name: loads[shapeId].length > 0 ? loads[shapeId][0].geo_shape_name : 'Unknown',
            load_capacity: supplier ? getTotalCapacity(supplier, isFormatToSmallScale, unit) : 0
          })
        })
      })

      if (!isPlanterAllocation) {
        const loadsData = loadList.reduce((listById, item) => {
          const value = item.field_geo_shape_uuid;
          listById[value] = (listById[value] || []).concat(item);
          return listById;
        }, {});

        Object.keys(loadsData).forEach((shapeId) => {
          const seedVariety = loadsData[shapeId].reduce((listById, item) => {
            const value = item.load_params && item.load_params.variety_name ? item.load_params.variety_name : null;
            listById[value] = (listById[value] || []).concat(item);
            return listById;
          }, {});

          Object.keys(seedVariety).forEach((item) => {
            let supplier = seedVariety[item] && seedVariety[item].length > 0 ? seedVariety[item] : null;
            dataList.push({
              variety_name: supplier && supplier[0].variety_name ? supplier[0].variety_name : 'Unknown',
              geo_shape_name: loadsData[shapeId].length > 0 ? loadsData[shapeId][0].field_geo_shape_name : 'Unknown',
              load_capacity: supplier ? getTotalCapacity(supplier, isFormatToSmallScale, unit) : 0
            })
          })
        })
      }

      dataList = dataList.sort((a, b) => sortFn("asc", "text", "variety_name", a, b));

      const unknownData = dataList.filter(item => (item.load_params && item.load_params.variety_name ? item.load_params.variety_name : null) === "Unknown");
      const knownData = dataList.filter(item => (item.load_params && item.load_params.variety_name ? item.load_params.variety_name : null) !== "Unknown");
      dataList = [...knownData, ...unknownData];
      return dataList;
    } else if (type === "planterWeightbySeedVariety") {
      const loadSquences = [];
      loadList.forEach((item) => {
        if (item.load_sequence && item.load_sequence.length > 0) {
          loadSquences.push(...item.load_sequence.map((e) => ({
            ...e,
            supplier: item.load_params && item.load_params.supplier ? item.load_params.supplier : null,
            variety_name: item.load_params && item.load_params.variety_name ? item.load_params.variety_name : null
          })))
        }
      });
      const loads = loadSquences.reduce((listById, item) => {
        const value = item.target_equipment_group_name;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = [];
      Object.keys(loads).forEach((shapeId) => {
        const seedVariety = loads[shapeId].reduce((listById, item) => {
          const value = item.load_params && item.load_params.variety_name ? item.load_params.variety_name : null;
          listById[value] = (listById[value] || []).concat(item);
          return listById;
        }, {});

        Object.keys(seedVariety).forEach((item) => {
          let supplier = seedVariety[item] && seedVariety[item].length > 0 ? seedVariety[item] : null;
          dataList.push({
            variety_name: supplier && supplier[0].variety_name ? supplier[0].variety_name : 'Unknown',
            target_equipment_group_name: loads[shapeId].length > 0 ? loads[shapeId][0].target_equipment_group_name : 'Unknown',
            load_capacity: supplier ? getTotalCapacity(supplier, isFormatToSmallScale, unit) : 0
          })
        })
      })
      dataList = dataList.sort((a, b) => sortFn("asc", "text", "variety_name", a, b));
      const unknownData = dataList.filter(item => (item.load_params && item.load_params.variety_name ? item.load_params.variety_name : null) === "Unknown");
      const knownData = dataList.filter(item => (item.load_params && item.load_params.variety_name ? item.load_params.variety_name : null) !== "Unknown");
      dataList = [...knownData, ...unknownData];
      return dataList;
    }
    else if (type === "fieldWeightbySeedSupplier") {
      const loadSquences = [];
      loadList.forEach((item) => {
        if (item.load_sequence && item.load_sequence.length > 0) {
          loadSquences.push(...item.load_sequence.map((e) => ({
            ...e,
            supplier: item.load_params && item.load_params.supplier ? item.load_params.supplier : null,
            variety_name: item.load_params && item.load_params.variety_name ? item.load_params.variety_name : null
          })))
        }
      });
      const loads = loadSquences.reduce((listById, item) => {
        const value = item.geo_shape_uuid;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = [];
      Object.keys(loads).forEach((shapeId) => {
        const seedVariety = loads[shapeId].reduce((listById, item) => {
          const value = item.load_params && item.load_params.supplier ? item.load_params.supplier : null;
          listById[value] = (listById[value] || []).concat(item);
          return listById;
        }, {});

        Object.keys(seedVariety).forEach((item) => {
          let supplier = seedVariety[item] && seedVariety[item].length > 0 ? seedVariety[item] : null;
          dataList.push({
            supplier: supplier && supplier[0].supplier ? supplier[0].supplier : 'Unknown',
            geo_shape_name: loads[shapeId].length > 0 ? loads[shapeId][0].geo_shape_name : 'Unknown',
            load_capacity: supplier ? getTotalCapacity(supplier, isFormatToSmallScale, unit) : 0
          })
        })
      })

      if (!isPlanterAllocation) {
        const loadsData = loadList.reduce((listById, item) => {
          const value = item.field_geo_shape_uuid;
          listById[value] = (listById[value] || []).concat(item);
          return listById;
        }, {});

        Object.keys(loadsData).forEach((shapeId) => {
          const seedVariety = loadsData[shapeId].reduce((listById, item) => {
            const value = item.load_params && item.load_params.supplier ? item.load_params.supplier : null;
            listById[value] = (listById[value] || []).concat(item);
            return listById;
          }, {});

          Object.keys(seedVariety).forEach((item) => {
            let supplier = seedVariety[item] && seedVariety[item].length > 0 ? seedVariety[item] : null;
            dataList.push({
              supplier: supplier && supplier[0].supplier ? supplier[0].supplier : 'Unknown',
              geo_shape_name: loadsData[shapeId].length > 0 ? loadsData[shapeId][0].field_geo_shape_name : 'Unknown',
              load_capacity: supplier ? getTotalCapacity(supplier, isFormatToSmallScale, unit) : 0
            })
          })
        })
      }

      dataList = dataList.sort((a, b) => sortFn("asc", "text", "supplier", a, b));
      const unknownData = dataList.filter(item => (item.load_params && item.load_params.supplier ? item.load_params.supplier : null) === "Unknown");
      const knownData = dataList.filter(item => (item.load_params && item.load_params.supplier ? item.load_params.supplier : null) !== "Unknown");
      dataList = [...knownData, ...unknownData];
      return dataList;
    } else if (type === "planterWeightbySeedSupplier") {
      const loadSquences = [];
      loadList.forEach((item) => {
        if (item.load_sequence && item.load_sequence.length > 0) {
          loadSquences.push(...item.load_sequence.map((e) => ({
            ...e,
            supplier: item.load_params && item.load_params.supplier ? item.load_params.supplier : null,
            variety_name: item.load_params && item.load_params.variety_name ? item.load_params.variety_name : null
          })))
        }
      });
      const loads = loadSquences.reduce((listById, item) => {
        const value = item.target_equipment_group_name;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = [];
      Object.keys(loads).forEach((shapeId) => {
        const seedVariety = loads[shapeId].reduce((listById, item) => {
          const value = item.load_params && item.load_params.supplier ? item.load_params.supplier : null;
          listById[value] = (listById[value] || []).concat(item);
          return listById;
        }, {});

        Object.keys(seedVariety).forEach((item) => {
          let supplier = seedVariety[item] && seedVariety[item].length > 0 ? seedVariety[item] : null;
          dataList.push({
            supplier: supplier && supplier[0].supplier ? supplier[0].supplier : 'Unknown',
            target_equipment_group_name: loads[shapeId].length > 0 ? loads[shapeId][0].target_equipment_group_name : 'Unknown',
            load_capacity: supplier ? getTotalCapacity(supplier, isFormatToSmallScale, unit) : 0
          })
        })
      })
      dataList = dataList.sort((a, b) => sortFn("asc", "text", "supplier", a, b));
      const unknownData = dataList.filter(item => (item.load_params && item.load_params.supplier ? item.load_params.supplier : null) === "Unknown");
      const knownData = dataList.filter(item => (item.load_params && item.load_params.supplier ? item.load_params.supplier : null) !== "Unknown");
      dataList = [...knownData, ...unknownData];
      return dataList;
    }
    /*  else if (type === "loadsPerSeedSupplier") {
      const loads = loadList.reduce((listById, item) => {
        const value = item.load_params &&  item.load_params.supplier ?item.load_params.supplier: null;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => ({
        supplier: replaceStr(loads[e][0].supplier),
        load_capacity: getTotalCapacity(loads[e], isFormatToSmallScale, unit),
        load_count: loads[e].length
      }));

      dataList = dataList.sort((a, b) => sortFn("desc", "number", "load_count", a, b));

      const unknownData = dataList.filter(item => (item.load_params &&  item.load_params.supplier ?item.load_params.supplier: null) === "Unknown");
      const knownData = dataList.filter(item => (item.load_params &&  item.load_params.supplier ?item.load_params.supplier: null) !== "Unknown");
      dataList = [...knownData, ...unknownData];
      return dataList;
    } else if (type === "loadsPerSeedVariety") {
      const loads = loadList.reduce((listById, item) => {
        const value = item.load_params &&  item.load_params.variety_name ?item.load_params.variety_name: null;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      let dataList = Object.keys(loads).map((e) => ({
        variety_name: replaceStr(loads[e][0].variety_name),
        load_capacity: getTotalCapacity(loads[e], isFormatToSmallScale, unit),
        load_count: loads[e].length
      }));

      dataList = dataList.sort((a, b) => sortFn("desc", "number", "load_count", a, b));

      const unknownData = dataList.filter(item => item.variety_name === "Unknown");
      const knownData = dataList.filter(item => item.variety_name !== "Unknown");
      dataList = [...knownData, ...unknownData];
      return dataList;
    }  */
    else if (type === "RateDetails") {
      const loads = loadList.reduce((listById, item) => {
        const value = item['rate_info'] && item['rate_info']['rate_uuid'] ? item['rate_info']['rate_uuid'] : null;
        if (!value) return listById;
        listById[value] = (listById[value] || []).concat(item);
        return listById;
      }, {});

      const result = Object.entries(loads).map(([rateUuid, trucks]) => {
        const truckCountMap = {};

        trucks.forEach(({ target_equipment_group_name }) => {
          if (!truckCountMap[target_equipment_group_name]) {
            truckCountMap[target_equipment_group_name] = 0;
          }
          truckCountMap[target_equipment_group_name]++;
        });

        const truck = Object.entries(truckCountMap).map(
          ([name, count]) => `${name} (${count})`
        );
        const rateInfo = (trucks[0] && trucks[0].rate_info) || null;

        let rateName = rateInfo && rateInfo.rate_name ? `${rateInfo.rate_name}${rateInfo.total
          ? ` ($${rateInfo.total})` : ''}` : '';

        return {
          rate_name: rateName,
          rate_uuid: rateUuid,
          eg_list: truck.toString(),
          rateInfo
        };
      });
      return result;
    }
    else {
      return [];
    }
  };

  useEffect(() => {
    const seedData = data && data.history ? data.history : [];
    if (seedData && seedData.length === 0) return setLoads(initialLoads);
    let newLoads = loads;

    Object.keys(loads).forEach(type => {
      if (type !== 'tareLoads') {
        const tableData = getTableDetails(type, seedData);
        newLoads[type] = {
          ...loads[type],
          body: tableData.map((item, index) => ({ id: index + 1, ...item })),
          isRequesting: isRequesting
        };
      }
    });

    if (newLoads["seedHistory"] && newLoads["seedHistory"].header) {
      newLoads["seedHistory"] = {
        ...newLoads["seedHistory"],
        header: newLoads["seedHistory"].header.map(headerItem => ({
          ...headerItem,
          isShow: (headerItem.key === "load_sequence" || headerItem.key === "completed")
            ? isPlanterAllocation
            : headerItem.isShow
        }))
      };
    }

    setLoads({ ...newLoads });
    setSeedHistory({ ...newLoads });

    let planterEgName = null;
    if (isTruck === 'false' && egId && categeryId === '4') {
      let seedSequence = (seedData[0] && seedData[0].load_sequence && seedData[0].load_sequence.length > 0) ?
        seedData[0].load_sequence.find((e) => e.target_equipment_group_uuid === egId) : null;
      if (seedSequence && seedSequence.target_equipment_group_name) {
        planterEgName = seedSequence.target_equipment_group_name
      }
    }

    if (type === 'crew' && crewId) setFilteredName(seedData[0].crew_name);
    if (isTruck === 'true' && egId) setFilteredName(seedData[0].target_equipment_group_name);
    if (isTruck === 'false' && egId && categeryId !== '4') setFilteredName(seedData[0].source_equipment_group_name);
    if (isTruck === 'false' && egId && categeryId === '4') setFilteredName(planterEgName);

  }, [data, isPlanterAllocation]);


  const handleDeleteChatBotConversation = async () => {
    if (aiChatBotId) {
      await axios.delete(`${CHAT_BOT_BASE_URL}/removeChat/${aiChatBotId}`);
    }
  }

  useEffect(() => {
    if (isAiBotEnable) {
      if (data && data.history && data.history.length > 0 && userSettings && userSettings.weight) {
        handleChatBot();
      } else {
        // setIsChatAvailable(false);
        handleDeleteChatBotConversation();
        dispatch(setAiChatBotId(""));
      }
    }
  }, [data, userSettings.weight, isAiBotEnable]);

  const handleChatBot = async () => {
    const userWeightSettings = userSettings.weight;
    let response = await axios.post(`${CHAT_BOT_BASE_URL}/loadList`, { user_id: JSON.stringify(userId), userWeightSettings, chatLoadHistory: data.history });
    const { data: botData } = response.data;
    if (botData === "success") {
      // setIsChatAvailable(true);
    }
  };

  useEffect(() => {
    const newLoads = loads;
    const { data, isRequesting } = tareLoadHistory;

    Object.keys(loads).forEach(type => {
      if (type === "tareLoads" || type === "tareLoadsForTheDay") {
        const tableData = getTableDetails(type, data);

        newLoads[type] = {
          ...loads[type],
          body: tableData.map((item, index) => ({ id: index + 1, ...item })),
          isRequesting: isRequesting
        };
      }

    });

    setLoads({ ...newLoads });
  }, [tareLoadHistory]);

  useEffect(() => {
    let loadList = data && Array.isArray(data.history)
      ? data.history
      : [];

    let loadListParams = [];

    loadList.forEach((item) => {
      if (item.hasOwnProperty("load_params") && item.load_params) {
        const params = item.load_params;

        Object.keys(params).forEach((e) => {
          if (params[e] && !loadListParams.includes(e)) {
            loadListParams.push(e);
            customColumns.push(e);
          }
        });
      }
    });

    setLoadParams(loadListParams);

    loadList = loadList
      .map((item) => {
        let listItem = { ...item };
        if (
          listItem &&
          loadListParams &&
          listItem.load_params &&
          loadListParams.length > 0
        ) {
          loadListParams.forEach((params) => {
            listItem[params] = listItem.load_params[params]
              ? listItem.load_params[params]
              : "Unknown";
          });
        } else if (loadListParams && loadListParams.length > 0) {
          loadListParams.forEach((params) => {
            listItem[params] = "Unknown";
          });
        }
        return listItem;
      })
      .sort((a, b) => {
        if (a.load_date && b.load_date) {
          const dateA = new Date(a.load_date).valueOf();
          const dateB = new Date(b.load_date).valueOf();
          return dateB - dateA;
        } else if (a.load_date) return -1;
        else if (b.load_date) return 1;
        else return 0;
      });

  }, [data.history]);


  useEffect(() => {
    let loadList = loads;
    if (selectedViewType && selectedViewType === 1 && loads) {
      if (loadParams && loadParams.length > 0) {
        loadList["seedHistory"].header = loadList["seedHistory"].header.filter(
          (item) => !item.isDynamic
        );
        loadParams.forEach((e) => {
          const header = loadList["seedHistory"].header;
          const isExists = header.filter((head) => head.key === e);
          if (isExists.length === 0) {
            loadList["seedHistory"].header.push({
              key: e,
              label: e
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase()),
              isPipeFilter: true,
              isSort: true,
              isShow: true,
              isExport: true,
              filter: e,
              isDynamic: true,
            });
          }
        });
        setLoads(loadList);
      } else {
        const dynamicHeader = loadList["seedHistory"].header.filter(
          (item) => item.isDynamic
        );
        if (
          loadParams.length === 0 &&
          dynamicHeader &&
          dynamicHeader.length > 0
        ) {
          loadList["seedHistory"].header = loadList[
            "seedHistory"
          ].header.filter((item) => !item.isDynamic);
          setLoads(loadList);
        }
      }
    }
  }, [loadParams]);


  const getFilteredData = (clear = false) => {
    let newLoads = loads;
    const { body } = newLoads.seedHistory;

    const filterColumns = ['crew_name', 'field_geo_shape_name', 'offload_geo_shape_name', 'operator_name', 'target_equipment_vendor_name', 'crop_name',
      'source_equipment_group_name', 'target_equipment_group_name', 'variety_name', 'supplier', 'seed_lot', 'load_sequence'];

    if (!clear && body && searchText.trim().length > 0) {
      const filteredList = body.filter((item, index) => {
        let data = null;

        filterColumns.forEach(e => {
          if (item && item[e] && Array.isArray(item[e]) && item[e].length >= 0 && e === 'load_sequence') {
            for (let i = 0; i < item[e].length; i++) {
              if (item[e][i] && item[e][i].geo_region_name && item[e][i].geo_region_name.toLowerCase().includes(searchText.toLowerCase())) {
                data = item;
              } else if (item[e][i] && item[e][i].target_equipment_group_name && item[e][i].target_equipment_group_name.toLowerCase().includes(searchText.toLowerCase())) {
                data = item;
              }
            }
          } else if (item && item[e] && !Array.isArray(item[e]) && item[e].toLowerCase().includes(searchText.toLowerCase())) {
            data = item;
          }
        });

        return data;
      });

      Object.keys(newLoads).forEach(type => {
        const tableData = getTableDetails(type, filteredList);
        newLoads[type] = {
          ...loads[type],
          body: tableData.map((item, index) => ({ id: index + 1, ...item })),
          isRequesting: filteredList.length === 0
        };
      });
      setLoads({ ...newLoads });
    }
    else setLoads({ ...seedHistory });
  };

  const isFiltered = () => {
    let isFilter = false;
    if (searchText.toString().trim().length !== 0) isFilter = true;
    if (!isFilter) {
      for (const key in filterIds) {
        const value = filterIds[key];
        if (value && (value.length !== 0)) {
          isFilter = true;
          break;
        }
      }
    }
    return isFilter;
  };

  const NetTotal = useMemo(() => {
    const { seedHistory } = loads;
    const loadWeight = (seedHistory.body.length > 0) ? parseFloat(getTotalCapacity(seedHistory.body, isFormatToSmallScale, unit).replace(/[^0-9.-]/g, '')) : 0;
    const tareWeight = Number(tareLoadHistory.loadDetails.totalCapacity);
    const netWeight = isFiltered() ? loadWeight : (loadWeight ? loadWeight - (tareWeight ? tareWeight : 0) : 0);
    return netWeight;
  }, [loads, tareLoadHistory, filterIds, searchText]);


  const totalTareWeight = useMemo(() => {
    if (!tareLoadHistory || !tareLoadHistory.loadDetails || !tareLoadHistory.loadDetails.totalCapacity) {
      return 0
    }
    const tareWeight = Number(unit.toWeight(tareLoadHistory.loadDetails.totalCapacity, 2));
    const formattedWeight = unit.toFixedOf(tareWeight, 0);
    return formatNumber(formattedWeight);
  }, [tareLoadHistory]);

  // const openVertexChatRoom = () => {
  //   const url = `${window.location.origin}/aichatroom?farm_uuid=${farmId}&from_date=${custom.from}&to_date=${custom.to}&plan_type_id=${planTypeId}&user_id=${userId}`;
  //   // const windowFeatures = 'width=500,height=600,left=200,top=200';
  //   const openWindow = 'location=yes,height=800,width=1400,scrollbars=yes,status=yes,left=200,top=200';

  //   window.open(url, '_blank', openWindow);
  // }

  const openVertexChatRoom = () => {
    setChatBotModal(true)
  }

  return (
    <Container fluid className='main_history_container'>
      <Row className='container-row w-100'>
        <Col className='container-col col-12 shadow bg-white rounded'>
          <SeedHeader
            loads={loads}
            selectedName={filteredName}
            NetTotal={NetTotal}
            totalTareWeight={totalTareWeight}
            selectedViewType={selectedViewType}
            getSeedHistoryList={getSeedHistoryList}
            getSeedTareHistory={getSeedTareHistory}
            isPlanterAllocation={isPlanterAllocation}
          />
          <SeedBody
            isRequesting={isRequesting}
            loads={loads}
            farmId={farmId}
            getFilteredData={getFilteredData}
            tareLoadHistory={tareLoadHistory}
            getSeedHistoryList={getSeedHistoryList}
            getSeedTareHistory={getSeedTareHistory}
            setSelectedViewType={setSelectedViewType}
            selectedViewType={selectedViewType}
            isPlanterAllocation={isPlanterAllocation}
          />
        </Col>
        {isAiBotEnable && allow("chatbot", "view") && <div className="chat-bot-icon">
          {userSettings.chat_bot_id === 4 ?
            <img src={geminiAiIcon} alt='Replybot' onClick={openVertexChatRoom} />
            :
            <img src={replyBotIcon} alt='Replybot' onClick={openVertexChatRoom} />}
        </div>}

      </Row>
      {isAiBotEnable && <Modal show={chatBotModal} onHide={() => onAiHide()} className={`load-history-chat-bot-container ai_chatbot_modal_container modal chat-bot-active`} >
        <Modal.Header className='' closeButton>
        </Modal.Header>
        <OffCanvasAi {...props} isVertexAi={true} defaultChatBot={aiChatHistory} setAiChatHistory={setAiChatHistory} />
      </Modal>}
    </Container>
  );
};

export default memo(SeedHistoryContent);